"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = void 0;
/**
 * Computed payment status for an order, derived at search time from the sum
 * of all payment installments versus the order total.
 *
 * unpaid        - no installments recorded (paidAmount == 0)
 * partially_paid - at least one installment exists but total is not yet covered
 * paid           - installments cover the full selected total
 */
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNPAID"] = "unpaid";
    PaymentStatus["PARTIALLY_PAID"] = "partially_paid";
    PaymentStatus["PAID"] = "paid";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
